<template>
  <div class="qes-list">
    <div class="list" @click="dialogTableVisible = true">
      <span>{{dataList.title}}</span>
      <i class="el-icon-arrow-right"></i>
    </div>
    <el-dialog
      title=""
      width="670px"
      :visible.sync="dialogTableVisible"
      header-cell-style="{background: '#F9F9F9'}"
    >
      <div class="title">{{dataList.title}}</div>
      <div class="date-source">
        <span>时间：{{dataList.createTime}}</span>
        <span>来源：{{dataList.userName}}</span>
      </div>
      <div class="content" v-html="dataList.content"></div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "hotPost",
  props: ["dataList"],
  data() {
    return {
      dialogTableVisible: false,
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.qes-list {
  width: 100%;
  height: 48px;
  border-bottom: 1px solid #efefef;
  .list {
    width: 100%;
    height: 100%;
    line-height: 48px;
    font-size: 16px;
    font-weight: 400;
    color: #121212;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }
  .title {
    width: 100%;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    color: #121212;
  }
  .date-source {
    width: 100%;
    height: 36px;
    line-height: 36px;
    background: #f9f9f9;
    margin-top: 16px;
    text-align: center;
    span {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      padding: 0 15px;
    }
  }
  .content {
    width: 100%;
    max-height: 540px;
    padding: 20px 20px 40px;
    text-align: justify;
    font-size: 15px;
    font-weight: 400;
    color: #333333;
    line-height: 26px;
    overflow: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/HelpList.vue